import React from 'react';
import { captureError } from '../hooks/useErrorTracking';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    captureError({
      type: 'react',
      level: 'critical',
      message: error?.message || 'React render error',
      stack: error?.stack,
      meta: {
        componentStack: errorInfo?.componentStack,
      },
      tags: ['react-boundary'],
    });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
